// Two-Factor Auth OTP verification error codes
export const OTP_SESSION_NOT_FOUND = 'otp-session-not-found';
export const OTP_EXPIRED = 'otp-expired';
export const OTP_ATTEMPTS_EXCEEDED = 'otp-attempts-exceeded';
export const OTP_INCORRECT = 'otp-incorrect';
export const OTP_RESEND_COOLDOWN = 'otp-resend-cooldown';
export const OTP_INVALID_REQUEST = 'invalid-request';
